// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1706031427516
      var cssReload = require("D:/WEB/Star Way/dunlop/static/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  